import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionService } from '../../session-service/session.service';
import { role } from 'src/app/shared/constants/role-enum';
import { Router } from '@angular/router';
import { TopNavigationService } from './top-nav.service';
import { RightSideDrawerService } from '../../right-side-drawer/right-side-drawer.service';
import { UserDataService } from '../../../core/services/user-data.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'top-navigation',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavigationComponent implements OnInit {
  private _destroyed$ = new Subject<void>();
  selectedNodeValue = 'node1';
  roleId: number;
  championRole = role.champion;
  adminRole = role.admin;
  ROUTE_URLs: any;
  isAdminScreen: boolean = false;
  @Output()
  displayNodeSeclectionChanged: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    public sessionService: SessionService,
    public _router: Router,
    public topNavigationService: TopNavigationService,
    public rightSideDrawerService: RightSideDrawerService,
    private userDataService: UserDataService,
  ) { }
  ngOnInit() {
    this.userDataService.userDetails$.pipe(
        takeUntil(this._destroyed$)
    ).subscribe(( { roleId } ) => {
        this.roleId = roleId;
    })     
      this.treeView();
      this.adminNavStatus();
  }

  manageTemplate() {
    this.rightSideDrawerService.openRightSideDrawer(
      'manage-credit-report-template'
    );
  }

  treeView(): void {
    const toggler = document.getElementsByClassName('caret');
    let i;

    for (i = 0; i < toggler.length; i++) {
      toggler[i].addEventListener('click', function () {
        this.parentElement.querySelector('.nested').classList.toggle('active');
        this.classList.toggle('caret-down');
      });
    }
  }
  onNodeClick(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target.attributes.id;
    this.selectedNodeValue = idAttr.nodeValue;

    this.displayNodeSeclectionChanged.emit(this.selectedNodeValue);
    console.log(this.selectedNodeValue);
    }

    adminNavStatus(): void {
        this._router.events.subscribe(event => {

            if (window.location.pathname.indexOf('/admin/user') > -1 || window.location.pathname.indexOf('/admin/master-activities') > -1 || window.location.pathname.indexOf('/admin/download-reports') > -1 || window.location.pathname.indexOf('/admin/release-update') > -1 || window.location.pathname.indexOf('/admin/action-logs') > -1 ) {
              this.isAdminScreen = true;
            } else {
              this.isAdminScreen = false;
            }
        });
    }

}
